import EventAggregator from 'sb-events'


export type RecurlyField = {
  instance: RecurlyNS.IndividualElement
  attach: RecurlyNS.IndividualElement['attach']
  validate: () => Promise<undefined | string>
  on: (event: string, handler: any) => void
  off: (event: string, handler: any) => void
  dispatchEvent: (event: string, ...args: any[]) => void
  setError: (error: string) => void
}

const useRecurlyField = (elementInstance): RecurlyField => {
  // "events" required to render errors from recurly.token() in RecurlyField (Recurly doesn't do it from box...)
  const events = new EventAggregator()

  return {
    instance: elementInstance,
    attach: elementInstance.attach.bind(elementInstance),
    validate: async () => {
      const error = elementInstance.state.valid ? undefined : 'Must be valid'

      events.dispatch('validate', error)

      return error
    },
    on: (event, handler) => {
      if (event === 'change') {
        elementInstance.on(event, handler)
      }
      else {
        events.subscribe(event, handler)
      }
    },
    off: (event, handler) => {
      if (event === 'change') {
        elementInstance.off(event, handler)
      }
      else {
        events.unsubscribe(event, handler)
      }
    },
    dispatchEvent: (event, ...args) => {
      events.dispatch(event, ...args)
    },
    setError: (error) => {
      events.dispatch('error', error)
    },
  }
}


export default useRecurlyField
